import { ExpandMore } from "@mui/icons-material";
import { Alert, Box, Collapse, IconButton, Typography } from "@mui/material";
import * as React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessageOpen: false, error: "" };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    const stackTrace = errorInfo.componentStack;

    console.error(error, errorInfo);
    this.setState((state) => ({
      ...state,
      error: error.toString(),
      stackTrace,
    }));
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Box
          sx={{
            display: "flex",
            flex: 1,
            width: 1,
            alignSelf: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Alert severity="error" sx={{ flex: 1, width: 1 }}>
            <Typography>Something went wrong:</Typography>
            <Typography variant="secondary">
              Failed to load section. {this.state.error}
            </Typography>
            <IconButton
              onClick={() =>
                this.setState((state) => ({
                  ...state,
                  errorMessageOpen: !state.errorMessageOpen,
                }))
              }
            >
              <ExpandMore />
            </IconButton>
            <Collapse
              in={this.state.errorMessageOpen}
              timeout="auto"
              unmountOnExit
            >
              {this.state.stackTrace}
            </Collapse>
          </Alert>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
